import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {API_URLS} from '../../../../../../../environments/env-routes';
import {APIHelper} from '../../../../../../../shared/services/api-helper/api-helper.service';
import {StorageService} from '../../../../../../../shared/services/storage/storage.service';

@Component({
  selector: 'app-dialog-download-file',
  templateUrl: './dialog-download-file.component.html',
  styleUrls: ['./dialog-download-file.component.scss']
})
export class DialogDownloadFileComponent implements OnInit {
  public selectedId: string;
  public loading: boolean;
  public file: any;
  public actualPercent: number;
  public bitsLoaded: number;
  public bitsTotal: number;
  private stop: boolean;
  private actualTimeout;
  public isPublic: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogDownloadFileComponent>,
    private api: APIHelper,
    private storage: StorageService
  ) {}

  ngOnInit() {
    this.actualTimeout = null;
    this.stop = false;
    this.actualPercent = 0;
    this.loading = true;
    this.file = this.data.file;
    this.selectedId = this.data.file.id;
    this.isPublic = this.data.isPublic;
    const data = {
      nodeIds: [this.selectedId]
    };

    // if (this.isPublic) {
      this.downloadFile(this.data.file.id);
    // } else {
    //  this.api.requestApi({ action: API_URLS.sharedLink.downloads, method: 'POST', datas: data }).then((res) => {
    //     this.loading = false;

    //     this.recursiveCheckDownload(res.id);
    //    });
    //  // this.downloadFile(this.data.file.id);
    // }
  }

  public onCancel() {
    this.stop = true;
    clearTimeout(this.actualTimeout);
    this.dialogRef.close(false);
  }

  private recursiveCheckDownload(id: string) {
    this.api
      .requestApi({
        action: API_URLS.nodes.downloadsState.replace(':id', id),
        addFormat: false
      })
      .then(res => {
        if (res.filesAdded) {
          this.bitsTotal = res.totalBytes;
          this.bitsLoaded = res.bytesAdded;
          this.actualPercent = Math.round(
            (this.bitsLoaded / this.bitsTotal) * 100
          );
        }

        if (this.stop) {
          return;
        } else if (res.status !== 'DONE') {
          // Attendre 1/2 secondes et relancer le call
          this.actualTimeout = setTimeout(() => {
            this.recursiveCheckDownload(id);
          }, 500);
        } else {
          this.downloadFile(id);
        }
      });
  }

  private downloadFile(id: string) {
    let url = '';
    const token = this.storage.getAsync({ key: 'token' });
    // if (this.isPublic) {
      url = this.api.url + API_URLS.nodes.downloadsContent.replace(':id', id);
      url += '?attachment=true&alf_ticket=' + token;
    // } else {
      // url =
      //   this.api.url + API_URLS.nodes.downloadsContent.replace(':sharedId', id);
      // url += '?attachment=true';
    // }
    window.open(url, '_blank');
    this.dialogRef.close(true);
  }


}
